export const createArcPath = (cx, cy, r1, r2, startAngle, endAngle) => {
  const startRad = (Math.PI / 180) * startAngle;
  const endRad = (Math.PI / 180) * endAngle;

  const x1 = cx + r2 * Math.cos(startRad);
  const y1 = cy + r2 * Math.sin(startRad);
  const x2 = cx + r2 * Math.cos(endRad);
  const y2 = cy + r2 * Math.sin(endRad);

  const x3 = cx + r1 * Math.cos(endRad);
  const y3 = cy + r1 * Math.sin(endRad);
  const x4 = cx + r1 * Math.cos(startRad);
  const y4 = cy + r1 * Math.sin(startRad);

  const largeArcFlagOuter = endAngle - startAngle <= 180 ? 0 : 1;
  const largeArcFlagInner = endAngle - startAngle <= 180 ? 0 : 1;

  return [
    `M ${x1.toFixed(2)},${y1.toFixed(2)}`,
    `A ${r2},${r2} 0 ${largeArcFlagOuter} 1 ${x2.toFixed(2)},${y2.toFixed(2)}`,
    `L ${x3.toFixed(2)},${y3.toFixed(2)}`,
    `A ${r1},${r1} 0 ${largeArcFlagInner} 0 ${x4.toFixed(2)},${y4.toFixed(2)}`,
    "Z",
  ].join(" ");
};

export const createSVGElement = (tagName) => {
  return document.createElementNS("http://www.w3.org/2000/svg", tagName);
};
